import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, onMounted, onBeforeUnmount, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipTrigger',
  props: {
    as: { default: 'span' },
    disabled: { type: Boolean, default: false },
    class: {}
  },
  setup(__props: any) {

const ctx = inject<any>('tooltipCtx', null)

const props = __props

const Tag = props.as as any
const el = ref<HTMLElement | null>(null)

onMounted(() => {
  if (ctx && 'triggerEl' in ctx) {
    ctx.triggerEl.value = el.value
  }
})

onBeforeUnmount(() => {
  if (ctx && 'triggerEl' in ctx) {
    ctx.triggerEl.value = null
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tag), {
    class: _normalizeClass(['tt-trigger', props.class]),
    tabindex: -1,
    ref_key: "el",
    ref: el,
    "aria-describedby": _unref(ctx)?.id,
    "aria-disabled": props.disabled || undefined,
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (!props.disabled && _unref(ctx)?.show())),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_unref(ctx)?.hide())),
    onFocus: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    onBlur: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "aria-describedby", "aria-disabled"]))
}
}

})